import React from 'react';
import './WhyUsPage.css';

import { PageTitle } from '../../../components';
import { Counter, WhyUs,  Services, Clients, Mission, ProjectSection, Industries, Process } from '../../../sections';




const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'Why Choose Us'} page={'Why Choose Us'} />

      <section className='whyUs-page'>

        <WhyUs /> {/* Why Choose Us section */}
        <Counter /> {/* Stats section */}
        <Services /> {/* Services section */}
        <Mission /> {/* Mission section */}
        <Process /> {/* Process slider */}
        <Industries /> {/* Industries Served */}
        <ProjectSection /> {/* Project Section */}
        <Clients /> {/* Clients section */}

      </section>

    </>
  );
}

export default AboutUs;